/**
 * PORTED — RO-3-11 / #44304.
 * Origin: `excellent/app/database/editor/_empty.tsx`.
 *
 * Changes, and only these:
 *   `"use client"`                        -> dropped (inert in this host)
 *   `useRouter` from next/navigation      -> `useNavigate` from @excellent/ui/router
 *   `router.push(...)`                    -> `navigate(...)`
 *
 * `CreateTableDialog` drives `ddl.createTable`, which IS mounted, so creating the
 * first table from here works and the navigate lands on a real route.
 */

import * as React from "react";
import { Button, CreateTableDialog, EmptyState } from "@excellent/ui";
import { Plus } from "@excellent/ui/icons";
import { useNavigate } from "@excellent/ui/router";

export function EditorEmptyState() {
  const navigate = useNavigate();
  const [open, setOpen] = React.useState(false);
  return (
    <>
      <EmptyState
        title="No user tables yet"
        description="Create one to start editing data."
        action={
          <Button
            size="icon-tb"
            aria-label="Create table"
            title="Create table"
            onClick={() => setOpen(true)}
          >
            <Plus className="size-4" />
          </Button>
        }
      />
      <CreateTableDialog
        open={open}
        onClose={() => setOpen(false)}
        onDone={(table) => navigate.push(`/database/editor/${encodeURIComponent(table)}`)}
      />
    </>
  );
}
